import React, { useState, useEffect } from 'react';
import './PreferenceForJob.css';
import { Container, Row, Col, Button, Form, Dropdown, Card } from 'react-bootstrap';
import { FaLaptop } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from "../../../Pages/Navbar/JobSeekerNavbar";
import Swal from 'sweetalert2';
import BaseUrl from '../../../ApiServices/BaseUrl';

const normalizeStoredCurrency = (value = '') => String(value || '').split(' | ')[0].trim();

function PreferenceForJob() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = location.state?.userId || user.id || '';
  const current_country = location.state?.current_country || '';
  const { state } = useLocation();
  const { job_position } = state || {};

  const storedMonthlycurrency = normalizeStoredCurrency(user.expected_monthly_salary_currency || '');
  const storedMonthlysalary = user.expected_monthly_salary || '';
  const storedMonthlysalaryusd = user.expected_monthly_salary_usd || '';

  const [formData, setFormData] = useState({
    user_id: userId,
    preffered_job_locations: ["Qatar", "Dubai", "Saudi"],
    other_job_location: '',
    expected_monthly_salary: storedMonthlysalary,
    expected_monthly_salary_usd: storedMonthlysalaryusd,
    expected_monthly_salary_qar: '',
    expected_monthly_salary_currency: storedMonthlycurrency, // NEW FIELD
    day_off_preference: 'Weekly Off',
    accommodation_preference: 'Live in/Live out',
    nationality: '',
    salary_negotiable: false
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSaved, setIsSaved] = useState(false);

  const getCurrencyCode = (value) => String(value || '').split(' ')[0].trim();

  const featuredLocations = ["UAE", "Dubai", "Saudi", "Qatar", "Kuwait", "Bahrain"];

  const locations = [
    "Qatar", "Dubai", "Saudi", "India",
  ];

  const accommodationOptions = [
    "Live in", "Live out", "Live in/Live out", "Sharing room",
    "Separate room", "Flexible", "To be discussed"
  ];

  const dayOffOptions = [
    "Weekly Off", "Friday-Saturday", "Saturday - Sunday",
    "Flexible", "I don't want Off", "To be discussed"
  ];

  const allCountryOptions = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
    "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
    "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
    "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
    "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",
    "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece",
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
    "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
    "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo",
    "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
    "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
    "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius",
    "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
    "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
    "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman",
    "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
    "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
    "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa",
    "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
    "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
    "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka",
    "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
    "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago",
    "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
    "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
    "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];

  const excludedDropdownLocations = new Set([
    ...featuredLocations,
    "Saudi Arabia",
    "United Arab Emirates"
  ]);

  const otherLocations = allCountryOptions.filter(
    (location) => !excludedDropdownLocations.has(location)
  );

  // Currency mapping with all country currencies
  const currencyMap = {
    "India": "INR (Indian Rupee)",
    "Philippines": "PHP (Philippine Peso)",
    "Indonesia": "IDR (Indonesian Rupiah)",
    "Sri Lanka": "LKR (Sri Lankan Rupee)",
    "Nepal": "NPR (Nepalese Rupee)",
    "Ghana": "GHS (Ghanaian Cedi)",
    "Kenya": "KES (Kenyan Shilling)",
    "Uganda": "UGX (Ugandan Shilling)",
    "Burundi": "BIF (Burundian Franc)",
    "Vietnam": "VND (Vietnamese Dong)",
    "Thailand": "THB (Thai Baht)",
    "Cambodia": "KHR (Cambodian Riel)",
    "Tanzania": "TZS (Tanzanian Shilling)",
    "Bangladesh": "BDT (Bangladeshi Taka)",
    "Ethiopia": "ETB (Ethiopian Birr)",
    "Sierra Leone": "SLL (Sierra Leonean Leone)",
    "Pakistan": "PKR (Pakistani Rupee)",
    "Myanmar": "MMK (Myanmar Kyat)",
    "Nigeria": "NGN (Nigerian Naira)",
    "Cameroon": "XAF (Central African CFA Franc)",
    "Rwanda": "RWF (Rwandan Franc)",
    "United States": "USD (US Dollar)",
    "United Kingdom": "GBP (British Pound Sterling)",
    "Canada": "CAD (Canadian Dollar)",
    "Australia": "AUD (Australian Dollar)",
    "New Zealand": "NZD (New Zealand Dollar)",
    "Germany": "EUR (Euro)",
    "France": "EUR (Euro)",
    "Italy": "EUR (Euro)",
    "Spain": "EUR (Euro)",
    "Netherlands": "EUR (Euro)",
    "UAE": "AED (UAE Dirham)",
    "Saudi Arabia": "SAR (Saudi Riyal)",
    "Qatar": "QAR (Qatari Riyal)",
    "Kuwait": "KWD (Kuwaiti Dinar)",
    "Bahrain": "BHD (Bahraini Dinar)",
    "Oman": "OMR (Omani Rial)",
    "Turkey": "TRY (Turkish Lira)",
    "Japan": "JPY (Japanese Yen)",
    "South Korea": "KRW (South Korean Won)",
    "Singapore": "SGD (Singapore Dollar)",
    "Malaysia": "MYR (Malaysian Ringgit)",
    "Hong Kong": "HKD (Hong Kong Dollar)",
    "Taiwan": "TWD (New Taiwan Dollar)",
    "China": "CNY (Chinese Yuan)",
    "Russia": "RUB (Russian Ruble)",
    "Brazil": "BRL (Brazilian Real)",
    "Mexico": "MXN (Mexican Peso)"
  };

  // Get unique currency options for dropdown
  const currencyOptions = [...new Set(Object.values(currencyMap))].sort();

  const conversionRates = {
    "INR": { toUSD: 0.012, toQAR: 0.044 },
    "PHP": { toUSD: 0.018, toQAR: 0.066 },
    "IDR": { toUSD: 0.000065, toQAR: 0.00024 },
    "LKR": { toUSD: 0.0031, toQAR: 0.011 },
    "NPR": { toUSD: 0.0075, toQAR: 0.027 },
    "GHS": { toUSD: 0.086, toQAR: 0.31 },
    "KES": { toUSD: 0.0069, toQAR: 0.025 },
    "UGX": { toUSD: 0.00027, toQAR: 0.00097 },
    "BIF": { toUSD: 0.00035, toQAR: 0.0013 },
    "VND": { toUSD: 0.000039, toQAR: 0.00014 },
    "THB": { toUSD: 0.028, toQAR: 0.10 },
    "KHR": { toUSD: 0.00024, toQAR: 0.00087 },
    "TZS": { toUSD: 0.00039, toQAR: 0.0014 },
    "BDT": { toUSD: 0.0091, toQAR: 0.033 },
    "ETB": { toUSD: 0.017, toQAR: 0.062 },
    "SLL": { toUSD: 0.000048, toQAR: 0.00017 },
    "PKR": { toUSD: 0.0036, toQAR: 0.013 },
    "MMK": { toUSD: 0.00048, toQAR: 0.0017 },
    "NGN": { toUSD: 0.00066, toQAR: 0.0024 },
    "XAF": { toUSD: 0.0016, toQAR: 0.0059 },
    "RWF": { toUSD: 0.00079, toQAR: 0.0029 },
    "USD": { toUSD: 1, toQAR: 3.64 },
    "GBP": { toUSD: 1.24, toQAR: 4.51 },
    "CAD": { toUSD: 0.74, toQAR: 2.69 },
    "AUD": { toUSD: 0.66, toQAR: 2.40 },
    "NZD": { toUSD: 0.61, toQAR: 2.22 },
    "EUR": { toUSD: 1.07, toQAR: 3.89 },
    "AED": { toUSD: 0.27, toQAR: 0.99 },
    "SAR": { toUSD: 0.27, toQAR: 0.97 },
    "QAR": { toUSD: 0.27, toQAR: 1 },
    "KWD": { toUSD: 3.25, toQAR: 11.82 },
    "BHD": { toUSD: 2.65, toQAR: 9.64 },
    "OMR": { toUSD: 2.60, toQAR: 9.46 },
    "TRY": { toUSD: 0.030, toQAR: 0.11 },
    "JPY": { toUSD: 0.0068, toQAR: 0.025 },
    "KRW": { toUSD: 0.00076, toQAR: 0.0028 },
    "SGD": { toUSD: 0.74, toQAR: 2.69 },
    "MYR": { toUSD: 0.21, toQAR: 0.76 },
    "HKD": { toUSD: 0.13, toQAR: 0.47 },
    "TWD": { toUSD: 0.031, toQAR: 0.11 },
    "CNY": { toUSD: 0.14, toQAR: 0.51 },
    "RUB": { toUSD: 0.011, toQAR: 0.040 },
    "BRL": { toUSD: 0.20, toQAR: 0.73 },
    "MXN": { toUSD: 0.059, toQAR: 0.21 }
  };

  useEffect(() => {
    const fetchJobSeekerData = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setFormData(prev => ({
              ...prev,
              nationality: data.nationality || prev.nationality || '',
              preffered_job_locations: (data.preffered_job_locations && data.preffered_job_locations.length > 0) ? data.preffered_job_locations : ["Qatar", "Dubai", "Saudi"],
              other_job_location: data.other_job_location || '',
              // Only update from API if values exist, otherwise keep localStorage values
              expected_monthly_salary: storedMonthlysalary || data.expected_monthly_salary || prev.expected_monthly_salary || '',
              expected_monthly_salary_usd: storedMonthlysalaryusd || data.expected_monthly_salary_usd || prev.expected_monthly_salary_usd || '',
              expected_monthly_salary_qar: data.expected_monthly_salary_qar || (data.expected_monthly_salary_usd ? Math.round(data.expected_monthly_salary_usd * 3.64).toString() : ''),
              expected_monthly_salary_currency: storedMonthlycurrency || normalizeStoredCurrency(prev.expected_monthly_salary_currency) || (data.nationality ? currencyMap[data.nationality] || '' : ''),
              day_off_preference: (data.day_off_preference && data.day_off_preference !== 'Not specified') ? data.day_off_preference : 'Weekly Off',
              accommodation_preference: (data.accommodation_preference && data.accommodation_preference !== 'Not specified') ? data.accommodation_preference : 'Live in/Live out',
              salary_negotiable: data.salary_negotiable || false
            }));
            setIsSaved(true);
          }
        } else if (response.status !== 404) {
          throw new Error('Failed to fetch job seeker data');
        }
      } catch (err) {
        console.error('Error fetching job seeker data:', err);
        setError(err.message);
      }
    };

    if (userId) {
      fetchJobSeekerData();
    }
  }, [userId]);

  // Set default currency when nationality changes
  useEffect(() => {
    if (formData.nationality && !formData.expected_monthly_salary_currency) {
      const defaultCurrency = currencyMap[formData.nationality];
      if (defaultCurrency) {
        setFormData(prev => ({
          ...prev,
          expected_monthly_salary_currency: defaultCurrency
        }));
      }
    }
  }, [formData.nationality]);

  const toggleSelection = (category, value, multiple = true) => {
    setFormData(prev => {
      const currentSelection = Array.isArray(prev[category]) ? prev[category] : [];

      if (multiple) {
        const alreadySelected = currentSelection.includes(value);
        const newSelection = alreadySelected
          ? currentSelection.filter(item => item !== value)
          : [...currentSelection, value];

        // Limit to 4 selections for preferred job locations
        if (category === 'preffered_job_locations' && newSelection.length > 4) {
          return prev;
        }

        return {
          ...prev,
          [category]: newSelection,
        };
      } else {
        return { ...prev, [category]: value };
      }
    });
    setIsSaved(false);
    setError(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validateFormData = async () => {
    const requiredFields = [
      // 'preffered_job_locations',
      // 'expected_monthly_salary',
      // 'day_off_preference',
      // 'accommodation_preference'
    ];

    const missingFields = requiredFields.filter(field => {
      if (Array.isArray(formData[field])) {
        return formData[field].length === 0;
      }
      return !formData[field];
    });

    if (missingFields.length > 0) {
      await Swal.fire({
        title: 'Missing Information!',
        text: 'Please fill in all required fields',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return false;
    }

    return true;
  };

  const saveData = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    setIsLoading(true);
    setError(null);

    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          expected_monthly_salary_currency: normalizeStoredCurrency(formData.expected_monthly_salary_currency)
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to save data');
      }

      // Update localStorage with the saved values
      const updatedUser = {
        ...user,
        expected_monthly_salary_currency: normalizeStoredCurrency(formData.expected_monthly_salary_currency),
        expected_monthly_salary: formData.expected_monthly_salary,
        expected_monthly_salary_usd: formData.expected_monthly_salary_usd,
        expected_monthly_salary_qar: formData.expected_monthly_salary_qar,
        nationality: formData.nationality
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));

      await Swal.fire({
        title: 'Success!',
        text: 'Your job preferences have been saved successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setIsSaved(true);
      return result;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      throw err;
    } finally {
      setIsLoading(false);
    }
  };
  const handleBack = () => {
    navigate('/professionalinfo', { state: { userId } });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle all three salary fields
    if (name === 'expected_monthly_salary' ||
      name === 'expected_monthly_salary_usd' ||
      name === 'expected_monthly_salary_qar') {

      const amount = parseFloat(value) || 0;

      // Extract currency code from the selected currency string (e.g., "AED (UAE Dirham)" -> "AED")
      let currencyCode = '';
      if (formData.expected_monthly_salary_currency) {
        currencyCode = getCurrencyCode(formData.expected_monthly_salary_currency);
      }

      const rates = conversionRates[currencyCode];

      let updatedFormData = { ...formData };

      if (rates) {
        if (name === 'expected_monthly_salary') {
          // Convert from selected currency to USD and QAR
          const usd = Math.round(amount * rates.toUSD); // Rounded
          const qar = Math.round(amount * rates.toQAR); // Rounded

          updatedFormData = {
            ...updatedFormData,
            expected_monthly_salary: Math.round(amount).toString(), // Rounded
            expected_monthly_salary_usd: usd.toString(),
            expected_monthly_salary_qar: qar.toString(),
          };
        }
        else if (name === 'expected_monthly_salary_usd') {
          // Convert from USD to selected currency and QAR
          const usdAmount = Math.round(amount);
          let localAmount = usdAmount;
          let qarAmount = Math.round(usdAmount * conversionRates['USD'].toQAR);

          if (currencyCode && rates) {
            localAmount = Math.round(usdAmount / rates.toUSD);
          }

          updatedFormData = {
            ...updatedFormData,
            expected_monthly_salary_usd: usdAmount.toString(),
            expected_monthly_salary: localAmount.toString(),
            expected_monthly_salary_qar: qarAmount.toString(),
          };
        }
        else if (name === 'expected_monthly_salary_qar') {
          // Convert from QAR to selected currency and USD
          const qarAmount = Math.round(amount);
          let localAmount = qarAmount;
          let usdAmount = Math.round(qarAmount / conversionRates['USD'].toQAR);

          if (currencyCode && rates) {
            localAmount = Math.round(qarAmount / rates.toQAR);
          }

          updatedFormData = {
            ...updatedFormData,
            expected_monthly_salary_qar: qarAmount.toString(),
            expected_monthly_salary: localAmount.toString(),
            expected_monthly_salary_usd: usdAmount.toString(),
          };
        }
        else if (name === 'expected_monthly_salary_qar') {
          // Convert from QAR to selected currency and USD
          const local = Math.round(amount / rates.toQAR); // Rounded
          const usd = Math.round(amount / conversionRates['USD'].toQAR); // Convert QAR to USD via USD rate

          updatedFormData = {
            ...updatedFormData,
            expected_monthly_salary_qar: Math.round(amount).toString(), // Rounded
            expected_monthly_salary: local.toString(),
            expected_monthly_salary_usd: usd.toString(),
          };
        }
      } else {
        // If no conversion rates, just round the value
        updatedFormData = {
          ...updatedFormData,
          [name]: Math.round(amount).toString() // Rounded
        };
      }

      setFormData(updatedFormData);
    } else {
      // For non-salary fields
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }

    setIsSaved(false);
    setError(null);
  };

  // Handle currency dropdown selection
  const handleCurrencySelect = (field, value) => {
    // If changing currency and there's an existing amount, convert it
    if (field === 'expected_monthly_salary_currency' && formData.expected_monthly_salary) {
      const oldCurrency = formData.expected_monthly_salary_currency;
      const newCurrency = value;

      if (oldCurrency && newCurrency && oldCurrency !== newCurrency) {
        const oldAmount = parseFloat(formData.expected_monthly_salary) || 0;

        // Extract currency codes
        const oldCurrencyCode = getCurrencyCode(oldCurrency);
        const newCurrencyCode = getCurrencyCode(newCurrency);

        // Get conversion rates
        const oldRates = conversionRates[oldCurrencyCode];
        const newRates = conversionRates[newCurrencyCode];

        if (oldRates && newRates) {
          // Convert old amount to USD first, then to new currency
          const amountInUSD = oldAmount * oldRates.toUSD;
          const newAmount = Math.round(amountInUSD / newRates.toUSD);

          // Update all three fields with converted amounts
          const newUsdAmount = Math.round(amountInUSD);
          const newQarAmount = Math.round(amountInUSD * conversionRates['USD'].toQAR);

          setFormData(prev => ({
            ...prev,
            expected_monthly_salary_currency: value,
            expected_monthly_salary: newAmount.toString(),
            expected_monthly_salary_usd: newUsdAmount.toString(),
            expected_monthly_salary_qar: newQarAmount.toString()
          }));

          setIsSaved(false);
          setError(null);
          return;
        }
      }
    }

    // If no conversion needed or conversion fails, just update the currency
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setIsSaved(false);
    setError(null);
  };

  const handleNegotiableToggle = () => {
    setFormData(prev => ({
      ...prev,
      salary_negotiable: !prev.salary_negotiable
    }));
    setIsSaved(false);
    setError(null);
  };

  const handleSave = async () => {
    await saveData();
  };

  const handleSaveNext = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();

      // Scroll to top and then navigate after a small delay
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });

      setTimeout(() => {
        navigate('/myskills', { state: { userId, current_country, job_position } });
      }, 100);
    } catch (err) {
      // Error already handled in saveData
    }
  };

  // Helper function to filter options for dropdown
  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Single Select Dropdown Component
  const SingleSelectDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = ''
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            <span style={{ color: selectedValue ? '#212529' : '#6c757d' }}>
              {selectedValue ? selectedValue : `${title}${required ? ' *' : ''}`}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValue === option} // This adds background color
                    onClick={() => {
                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                    style={{
                      backgroundColor: selectedValue === option ? '#e7f1ff' : 'transparent',
                      color: selectedValue === option ? '#0d6efd' : '#212529'
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Multi Select Dropdown Component for Job Locations
  const MultiSelectDropdown = ({
    title,
    field,
    options,
    selectedValues = [],
    onSelect,
    required = false,
    menuClassName = '',
    maxSelections = 4
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    const handleSelect = (option) => {
      if (selectedValues.includes(option)) {
        // Remove if already selected
        const newValues = selectedValues.filter(item => item !== option);
        onSelect(field, newValues);
      } else {
        // Add if not selected and under limit
        if (selectedValues.length < maxSelections) {
          const newValues = [...selectedValues, option];
          onSelect(field, newValues);
        } else {
          alert(`You can only select up to ${maxSelections} options`);
        }
      }
    };

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            <span style={{ color: selectedValues.length > 0 ? '#212529' : '#6c757d' }}>
              {selectedValues.length > 0
                ? `${title} (${selectedValues.length} selected)`
                : `${title}${required ? ' *' : ''}`
              }
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValues.includes(option)}
                    onClick={() => handleSelect(option)}
                    style={{
                      backgroundColor: selectedValues.includes(option) ? '#e7f1ff' : 'transparent',
                      color: selectedValues.includes(option) ? '#0d6efd' : '#212529'
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {option}
                    </div>
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Handle dropdown selection
  const handleDropdownSelect = (field, value) => {
    if (field === 'day_off_preference' || field === 'accommodation_preference') {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    setIsSaved(false);
    setError(null);
  };

  // Handle multi-select dropdown selection
  const handleMultiSelect = (field, values) => {
    if (field === 'preffered_job_locations_dropdown') {
      setFormData(prev => ({
        ...prev,
        preffered_job_locations: values
      }));
    }
    setIsSaved(false);
    setError(null);
  };

  // Combine all locations for the dropdown
  const allLocations = [...new Set([...locations, ...otherLocations])];

  return (
    <>
      <Navbar />
      <div className="preference-wrapper" style={{ marginTop: "84px", width: '96%' }}>
        <Container className="mt-4 px-4 pb-5">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <Card className="shadow border-0 preference-card">
            <Card.Header className="preference-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-briefcase me-2"></i>
                Your Preference for Job
              </h2>
            </Card.Header>
            <Card.Body className="preference-body">
              {/* Job Location Section */}
              <h4 className="mb-3 fw-semibold text-dark">
                <div className="d-flex flex-row align-items-start align-items-md-center">
                  <div>
                    What is prefer job Location <span className="text-danger ms-1"></span>
                  </div>
                  <p className="fw-semibold language-note ms-0 ms-md-3 mb-0 mt-2 mt-md-0">
                    (You can select up to 4 Countries)
                  </p>
                </div>
              </h4>

              {/* Display specific locations as buttons matching the image */}
              <Row className="g-3 mb-3">
                {featuredLocations.map((location, idx) => {
                  return (
                    <Col xs={6} md={4} key={idx}>
                      <Button
                        className={`location-btn w-100 ${formData.preffered_job_locations.includes(location) ? 'selected' : ''}`}
                        onClick={() => toggleSelection('preffered_job_locations', location)}
                        disabled={
                          formData.preffered_job_locations.length >= 4 &&
                          !formData.preffered_job_locations.includes(location)
                        }
                      >
                        {location}
                      </Button>
                    </Col>
                  );
                })}
              </Row>

              {/* Display selected locations as chips */}
              {formData.preffered_job_locations.length > 0 && (
                <div className="mb-3">
                  <h6 className="mb-2">Selected Locations:</h6>
                  <div className="d-flex flex-wrap gap-2">
                    {formData.preffered_job_locations.map((location, idx) => (
                      <div key={idx} className="badge bg-primary d-flex align-items-center">
                        {location}
                        <button
                          type="button"
                          className="btn-close btn-close-white ms-2"
                          style={{ fontSize: '0.5rem' }}
                          onClick={() => toggleSelection('preffered_job_locations', location)}
                          aria-label="Remove"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Multi-select Dropdown for remaining locations */}
              <div className="mb-3">
                <MultiSelectDropdown
                  title="Select other job locations"
                  field="preffered_job_locations_dropdown"
                  options={allLocations.filter((loc) => !excludedDropdownLocations.has(loc))}
                  selectedValues={formData.preffered_job_locations.filter(
                    (loc) => !excludedDropdownLocations.has(loc)
                  )}
                  onSelect={handleMultiSelect}
                  maxSelections={4}
                  menuClassName="personalinfo-nationality-menu"
                />
              </div>


              {/* Salary Section */}
              <div className="mt-5">
                <h4 className="Expected-currency fw-semibold">
                  Select Currency for your Salary<span className="text-danger"></span>
                </h4>

                {/* Negotiable Button and Currency Dropdown in same row */}
                <Row className="mt-3">
                  {/* <Col xs={12} md={6} className="mb-2">
                    <Button
                      className={`language-btn negotiable-btn w-100 ${formData.salary_negotiable ? 'selected' : ''}`}
                      onClick={handleNegotiableToggle}
                    >
                      {formData.salary_negotiable ? '✓ Negotiable' : 'Negotiable'}
                    </Button>
                  </Col> */}
                  <Col xs={12} md={12} className="mb-2">
                    <SingleSelectDropdown
                      title="Select Country currency"
                      field="expected_monthly_salary_currency"
                      placeholder="Select Currency for your Salary"
                      options={currencyOptions}
                      selectedValue={formData.expected_monthly_salary_currency}
                      onSelect={handleCurrencySelect}
                      menuClassName="personalinfo-nationality-men"
                    />
                  </Col>
                </Row>

                {/* Salary input boxes */}
                <Row className="mt-1 g-3">

                  {/* Local Currency Input */}
                  <Col xs={12} md={4}>
                    <div className="input-group">
                      <span className="input-group-text" style={{ backgroundColor: '#aec9f3', marginRight: '2px' }}>
                        {formData.expected_monthly_salary_currency
                          ? getCurrencyCode(formData.expected_monthly_salary_currency)
                          : 'Currency'}
                      </span>
                      <Form.Control
                        type="number"
                        name="expected_monthly_salary"
                        placeholder={formData.expected_monthly_salary_currency
                          ? `Type your salary in ${getCurrencyCode(formData.expected_monthly_salary_currency)} (leave empty for Negotiable)`
                          : 'Select currency first'}
                        className="preference-input"
                        value={formData.expected_monthly_salary}
                        onChange={handleChange}
                        disabled={!formData.expected_monthly_salary_currency}
                      />
                    </div>
                  </Col>

                  {/* USD Input */}
                  <Col xs={12} md={4}>
                    <div className="input-group">
                      <span className="input-group-text" style={{ backgroundColor: '#aec9f3', marginRight: '2px' }}>USD</span>
                      <Form.Control
                        type="number"
                        name="expected_monthly_salary_usd"
                        placeholder="USD (leave empty for Negotiable)"
                        className="preference-input"
                        value={formData.expected_monthly_salary_usd}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  {/* QAR Input */}
                  <Col xs={12} md={4}>
                    <div className="input-group">
                      <span className="input-group-text" style={{ backgroundColor: '#aec9f3', marginRight: '2px' }}>QAR</span>
                      <Form.Control
                        type="number"
                        name="expected_monthly_salary_qar"
                        placeholder="QAR (leave empty for Negotiable)"
                        className="preference-input"
                        value={formData.expected_monthly_salary_qar}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>

                {/* {formData.salary_negotiable && (
                  <div className="mt-2 alert alert-info">
                    <strong>Salary is set as negotiable.</strong>
                  </div>
                )} */}
              </div>

              {/* Day off Preference - Single Select */}
              <div className="mt-5">
                <h4 className="fw-semibold">
                  Day off Preference <span className="text-danger"></span>
                </h4>
                <Row className="mt-1">
                  {/* First row with 2 columns like a table */}
                  {dayOffOptions.slice(0, 4).map((option, index) => (
                    <Col xs={6} md={3} key={index} className="mb-2">
                      <Button
                        className={`preference-button w-100 ${formData.day_off_preference === option ? 'selected' : ''
                          }`}
                        onClick={() => toggleSelection('day_off_preference', option, false)}
                      >
                        {option}
                      </Button>
                    </Col>
                  ))}

                  {/* Single Select Dropdown for remaining options */}
                  {dayOffOptions.length > 4 && (
                    <Col xs={12}>
                      <SingleSelectDropdown
                        title="Select other day off preference"
                        field="day_off_preference"
                        options={dayOffOptions.slice(4)}
                        selectedValue={dayOffOptions.slice(4).includes(formData.day_off_preference) ? formData.day_off_preference : ''}
                        onSelect={handleDropdownSelect}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </Col>
                  )}
                </Row>

                {/* Show selected day off preference */}
                {formData.day_off_preference && (
                  <div className="mt-2">
                    <p className="mb-0">
                      <strong>Selected:</strong> {formData.day_off_preference}
                    </p>
                  </div>
                )}
              </div>

              {/* Accommodation Preference - Single Select */}
              <div className="mt-5">
                <h4 className="fw-semibold">
                  Accommodation Preference <span className="text-danger"></span>
                </h4>
                <Row className="mt-1">
                  {/* First 2x2 grid like a table */}
                  {accommodationOptions.slice(0, 4).map((option, index) => (
                    <Col xs={6} md={3} key={index} className="mb-2">
                      <Button
                        className={`location-btn w-100 ${formData.accommodation_preference === option ? 'selected' : ''
                          }`}
                        onClick={() =>
                          setFormData({
                            ...formData,
                            accommodation_preference:
                              formData.accommodation_preference === option ? '' : option,
                          })
                        }
                      >
                        {option}
                      </Button>
                    </Col>
                  ))}

                  {/* Single Select Dropdown for remaining options */}
                  {accommodationOptions.length > 4 && (
                    <Col xs={12}>
                      <SingleSelectDropdown
                        title="Select other Accommodation"
                        field="accommodation_preference"
                        options={accommodationOptions.slice(4)}
                        selectedValue={accommodationOptions.slice(4).includes(formData.accommodation_preference) ? formData.accommodation_preference : ''}
                        onSelect={handleDropdownSelect}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </Col>
                  )}
                </Row>

                {/* Show selected accommodation preference */}
                {formData.accommodation_preference && (
                  <div className="mt-2">
                    <p className="mb-0">
                      <strong>Selected:</strong> {formData.accommodation_preference}
                    </p>
                  </div>
                )}
              </div>

              {/* Navigation Buttons */}
              <div className="mt-5 d-flex justify-content-between gap-3 flex-row" style={{ width: "100%" }}>
                <button
                  type="button"
                  className="nav-btn text-center"
                  style={{ flex: 1 }}
                  onClick={handleBack}
                  disabled={isLoading}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="nav-btn text-center"
                  style={{ flex: 1 }}
                  onClick={handleSaveNext}
                  disabled={isLoading}
                >
                  {isLoading ? 'Saving...' : 'Next'}
                </button>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default PreferenceForJob;
